<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
  <circle cx="12" cy="5" r="1.75" fill="currentColor" />
  <circle cx="12" cy="12" r="1.75" fill="currentColor" />
  <circle cx="12" cy="19" r="1.75" fill="currentColor" />
</svg>
